import { isArray, isNullOrUnDef, isNumber, isString, isIterable, isObject, isEntries } from '../is';
export { struct } from './struct/index';

/**
 * 转Entries
 * @param {Object|Array} obj
 * @returns {any[]}
 */
export function toEntries(obj) {
  if (isEntries(obj)) return obj;

  return Object.entries(obj);
}

export function toObject(value) {
  if (isEntries(value)) return Object.fromEntries(value);
  if (isArray(value)) return { ...value };
  return isObject(value) ? value : {};
}

export function toMap(obj) {
  if (isEntries(obj)) return new Map(obj);
  if (isArray(obj)) return new Map(toEntries(obj));
  return new Map(toEntries(obj));
}

export function toArray(value) {
  if (isNullOrUnDef(value)) return [];
  if (isArray(value)) return value;
  if (isString(value) || isNumber(value)) return [value];
  if (isIterable(value)) return [...value];
  return [value];
}

/**
 * 转小写字母
 * @param {string} v
 * @returns {string}
 */
export function toLowerCase(v) {
  if (!isString(v)) return;
  return v.toLowerCase();
}

/**
 * 转大写字母
 * @param {string} v
 * @returns {string}
 */
export function toUpperCase(v) {
  if (!isString(v)) return;
  return v.toUpperCase();
}
